module.exports = __webpack_public_path__ + "static/media/image1.8bbd5ec7.jpg";